import { ICONS, type IconName } from "./icons";

/** Inline SVG line icon from the prototype set. Paths are static constants, never user input. */
export function Icon({ name, className = "" }: { name: IconName; className?: string }) {
  return <svg className={`i ${className}`} viewBox="0 0 24 24" aria-hidden="true" dangerouslySetInnerHTML={{ __html: ICONS[name] }} />;
}
